import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Card, Button } from '@mui/material';
import { useMediaQueries } from '../usecontext/UseProvider';
import { FaPlay } from 'react-icons/fa';
import { getFollowUsMedia } from '../services/FollowUsMedia';
import Header from '../adminComponents/header/Header';
import MediaManagerModal from '../adminComponents/mediamanagermodal/MediaManagerModal';

const MediaManagerPage = () => {
    const { isSmallScreen, isLargeScreen, setLoading } = useMediaQueries();
    const [followUsMediaData, setFollowUsMediaData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState(null);

    const getFollowUsMediaData = async () => {
        try {
            setLoading(true);
            const response = await getFollowUsMedia();
            setFollowUsMediaData(response?.followUsMediaData);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getFollowUsMediaData();
    }, []);

    const handleOnEdit = (media) => {
        setSelectedMedia(media);
        setOpenModal(true);
    };

    const handleUpdateSuccess = () => {
        getFollowUsMediaData(); // Refresh the data after successful update
    };

    return (
        <>
            <Header title="Media Manager" />
            <Box sx={{ pt: 3 }}>
                <Grid container spacing={isLargeScreen ? 2 : 3}>
                    {followUsMediaData?.map((video, index) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={3}
                            key={index}
                        >
                            <Card
                                sx={{
                                    backgroundColor: 'transparent',
                                    position: 'relative',
                                    boxShadow: 'none', 
                                    textAlign: 'center'
                                }}
                            >
                                <Box
                                    component="img"
                                    src={video?.thumbnail_media?.url}
                                    alt={video.title}
                                    sx={{
                                        borderRadius: '20px',
                                        height: '330px',
                                        maxWidth: { lg: '300px', xs: '100%' },
                                        objectFit: 'cover',
                                    }}
                                />
                                <Box
                                    onClick={() => window.open(`${video?.thumbnail_media_url}`)}
                                    sx={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        textAlign: 'center',
                                        color: '#fff',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <FaPlay style={{ height: '20px', width: '20px' }} />
                                </Box>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '75px',
                                        bottom: '0',
                                        transform: 'translate(-50%, -50%)',
                                        color: '#fff',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '5px'
                                        }}
                                    >
                                        <Typography variant='body2'>{video.title}</Typography>
                                    </div>
                                </Box>
                                <Button
                                    variant="varient"
                                    size={isSmallScreen ? 'small' : 'medium'}
                                    sx={{
                                        fontWeight: 400,
                                        backgroundColor: '#01A0E2',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        mt: 3,
                                        px: 3,
                                    }}
                                    onClick={() => handleOnEdit(video)}>
                                    Change Image & Link
                                </Button>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <MediaManagerModal 
                open={openModal} 
                setOpen={setOpenModal} 
                mediaData={selectedMedia}
                onUpdateSuccess={handleUpdateSuccess}
            />
        </>
    )
}

export default MediaManagerPage;